<template>
    <section class="section">
        <div class="container">
            <div class="columns is-desktop">
                <div class="column is-8 is-offset-2">
                    <h1 class="title level">
                        <span class="flex">{{ $t('doctorRegister_title') }}</span>
                        <button @click.prevent="logout" class="button is-secondary">
                            <span>{{ $t('logout_link_label') }}</span>
                        </button>
                    </h1>

                    <hr>

                    <div class="box">
                        <form v-on:keyup.13="submit">
                            <div class="columns">
                                <div class="column is-3">
                                    <h4 class="subtitle" v-text="$t('doctor_legend')"></h4>
                                </div>
                                <div class="column is-7">
                                    <div class="field has-text-centered">
                                        <a href="#" @click.prevent="toggleAvatarSelector(true)">
                                            <avatar :avatar="newDoctor.avatar" name="" class="is-inline image is-96x96"></avatar>
                                        </a>
                                        <span class="is-size-7 has-text-grey is-block">{{ $t('click_to_change_avatar') }}</span>
                                    </div>
                                    <div class="columns">
                                        <div class="column">
                                            <div class="field">
                                                <label class="label" v-text="$t('first_name_label')"></label>
                                                <p class="control has-icon has-icons-right">
                                                    <input
                                                        v-validate="'required'"
                                                        :class="{'input': true, 'is-danger': errors.has('doctor.firstName') }"
                                                        v-model="newDoctor.firstName"
                                                        name="doctor.firstName"
                                                        type="text">
                                                    <span v-show="errors.has('doctor.firstName')" class="icon is-right is-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="column">
                                            <div class="field">
                                                <label class="label" v-text="$t('last_name_label')"></label>
                                                <p class="control has-icon has-icons-right">
                                                    <input
                                                        v-validate="'required'"
                                                        :class="{'input': true, 'is-danger': errors.has('doctor.lastName') }"
                                                        v-model="newDoctor.lastName"
                                                        name="doctor.lastName"
                                                        type="text">
                                                    <span v-show="errors.has('doctor.lastName')" class="icon is-right is-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="field">
                                        <label class="label" v-text="$t('contact_email_label')"></label>
                                        <p class="control has-icon has-icons-right">
                                            <input
                                                v-validate="'required|email'"
                                                :class="{'input': true, 'is-danger': errors.has('contactEmail') }"
                                                v-model="newDoctor.contactEmail"
                                                name="contactEmail"
                                                type="email">
                                            <span v-show="errors.has('contactEmail')" class="icon is-right is-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                                            <span v-show="errors.has('contactEmail')" class="help is-danger">{{ $t('email_error') }}</span>
                                        </p>
                                    </div>
                                    <div class="field">
                                        <label class="label" v-text="$t('medical_practice_label')"></label>
                                        <div class="control has-icon has-icons-right">
                                            <div class="select is-fullwidth">
                                                <select v-model="newDoctor.type">
                                                    <option v-for="type in medicalPractices" :value="type">{{ $t('type_' + type) }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="field">
                                        <label class="label" v-text="$t('inami_label')"></label>
                                        <p class="control has-icon has-icons-right">
                                            <input
                                                v-validate="'required|numeric|min:11|max:11'"
                                                :class="{'input': true, 'is-danger': errors.has('doctor.inami') }"
                                                v-model="newDoctor.inami"
                                                name="doctor.inami"
                                                type="inami">
                                            <span v-show="errors.has('doctor.inami')" class="icon is-right is-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                                            <span v-show="errors.has('doctor.inami')" class="help is-danger">{{ $t('inami_error') }}</span>
                                        </p>
                                    </div>
                                    <div class="field">
                                        <label class="checkbox">
                                            <input
                                                type="checkbox"
                                                v-model="newDoctor.isRegulated">
                                                <span v-html="$t('is_regulated_label')"></span>
                                        </label>
                                    </div>

                                    <div class="field" :class="Object.keys(countries).length == 1 ? 'is-hidden' : ''">
                                        <label class="label" v-text="$t('DoctorProfile.country_label')"></label>
                                        <div class="control has-icon has-icons-right">
                                            <div class="select">
                                                <select v-model="newDoctor.countryId">
                                                    <option v-for="country in countries" :value="country.id" v-text="$t(`Countries_${countr.code}`)"></option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field">
                                        <label class="label" v-text="$t('language_label')"></label>
                                        <div class="control has-icon has-icons-right">
                                            <div class="select">
                                                <select v-model="newDoctor.language" name="doctor.language">
                                                    <option v-for="(language, id) in languages" :value="language.code">{{ language.name }}</option>
                                                </select>
                                            </div>
                                            <span v-show="errors.has('doctor.language')" class="icon is-right is-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                                            <span v-show="errors.has('doctor.language')" class="help is-danger">{{ errors.first('doctor.language') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-for="(office, key) in newOffices" :key="key">
                                <hr>
                                <div class="columns">
                                    <div class="column is-3">
                                        <h4 class="subtitle" v-text="$t('office_legend')"></h4>
                                    </div>
                                    <div class="column is-7">
                                        <div class="field">
                                            <label class="label" v-text="$t('name_label')"></label>
                                            <p class="control has-icon has-icons-right">
                                                <input
                                                    v-validate="'required'"
                                                    :class="{'input': true, 'is-danger': errors.has(`offices.${key}.name`) }"
                                                    v-model="office.name"
                                                    :name="`offices.${key}.name`"
                                                    type="name">
                                                <span v-show="errors.has('offices.' + key + '.name')" class="icon is-right is-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                                            </p>
                                        </div>
                                        <div class="columns">
                                            <div class="column is-8">
                                                <div class="field">
                                                    <label class="label" v-text="$t('street_name_label')"></label>
                                                    <p class="control has-icon has-icons-right">
                                                        <input
                                                            v-validate="'required'"
                                                            :class="{'input': true, 'is-danger': errors.has(`offices.${key}.streetName`) }"
                                                            v-model="office.streetName"
                                                            :name="`offices.${key}.streetName`"
                                                            type="streetName">
                                                        <span v-show="errors.has('offices.' + key + '.streetName')" class="icon is-right is-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="column is-4">
                                                <div class="field">
                                                    <label class="label" v-text="$t('street_number_label')"></label>
                                                    <p class="control has-icon has-icons-right">
                                                        <input
                                                            v-validate="'required'"
                                                            :class="{'input': true, 'is-danger': errors.has(`offices.${key}.streetNumber`) }"
                                                            v-model="office.streetNumber"
                                                            :name="`offices.${key}.streetNumber`"
                                                            type="streetNumber">
                                                        <span v-show="errors.has('offices.' + key + '.streetNumber')" class="icon is-right is-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="columns">
                                            <div class="column is-4">
                                                <div class="field">
                                                    <label class="label" v-text="$t('zip_code_label')"></label>
                                                    <p class="control has-icon has-icons-right">
                                                        <input
                                                            v-validate="'required'"
                                                            :class="{'input': true, 'is-danger': errors.has(`offices.${key}.zipCode`) }"
                                                            v-model="office.zipCode"
                                                            :name="`offices.${key}.zipCode`"
                                                            type="zipCode">
                                                        <span v-show="errors.has('offices.' + key + '.zipCode')" class="icon is-right is-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="column is-8">
                                                <div class="field">
                                                    <label class="label" v-text="$t('locality_label')"></label>
                                                    <p class="control has-icon has-icons-right">
                                                        <input
                                                            v-validate="'required'"
                                                            :class="{'input': true, 'is-danger': errors.has(`offices.${key}.locality`) }"
                                                            v-model="office.locality"
                                                            :name="`offices.${key}.locality`"
                                                            type="locality">
                                                        <span v-show="errors.has('offices.' + key + '.locality')" class="icon is-right is-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="field">
                                            <label class="label" v-text="$t('country_label')"></label>
                                            <p class="control">
                                                <div :class="{'select is-fullwidth': true, 'is-danger': errors.has(`offices.${key}.countryId`) }">
                                                    <select
                                                        class="is-block"
                                                        v-model="office.countryId"
                                                        :name="`offices.${key}.countryId`"
                                                        v-validate="'required'"
                                                        :disabled="Object.keys(countries).length == 1">
                                                        <option v-bind:value="null">{{ $t('select_country_label') }}</option>
                                                        <option v-for="(country, id) in countries" v-text="$t(`Countries_${countr.code}`)" v-bind:value="id"></option>
                                                    </select>
                                                </div>
                                            </p>
                                            <p v-show="errors.has('offices.' + key + '.countryId')" class="help is-danger">{{ $t('select_country_label') }}</p>
                                        </div>

                                        <div class="field">
                                            <label class="label" v-text="$t('phone_label')"></label>
                                            <p class="control has-icon has-icons-right">
                                                <input
                                                    v-validate="{
                                                        required: true,
                                                        regex: getPhoneRegex(key)
                                                    }"
                                                    :class="{'input': true, 'is-danger': errors.has(`offices.${key}.phone`) }"
                                                    v-model="office.phone"
                                                    :name="`offices.${key}.phone`"
                                                    :placeholder="getCurrentCountryPhonePrefix(office) + '...'"
                                                    type="phone">
                                                <span v-show="errors.has('offices.' + key + '.phone')" class="icon is-right is-danger has-text-danger"><i class="mdi mdi-alert-circle mdi-24px"></i></span>
                                            </p>
                                            <span v-show="errors.has('offices.' + key + '.phone')" class="help is-danger">{{ $t('DoctorOffice.phone_error', { prefix: getCountryPhonePrefix(key) }) }}</span>
                                        </div>

                                        <button class="button" @click.prevent="removeOffice(key)" v-if="key != 0">
                                            <b-icon icon="close-circle"></b-icon>
                                            <span v-text="$t('remove_office_button_label')"></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <div class="columns">
                                <div class="column is-7 is-offset-3">
                                    <div>
                                        <label class="checkbox">
                                            <input
                                                type="checkbox"
                                                v-model="acceptTerms"
                                                v-validate="'required'"
                                                name="acceptTerms">
                                                <span v-html="$t('accept_terms_label')"></span>
                                        </label>
                                        <span v-show="errors.has('acceptTerms')" class="help is-danger">{{ $t('accept_terms_error') }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="notification is-danger mb-4" v-if="errors.any()">
                                {{ $t('fields_are_missing') }}
                            </div>
                            <div class="notification is-danger mb-4" v-if="error">
                                <button class="delete" @click.prevent="deleteError"></button>
                                {{ error }}
                            </div>
                            <hr>
                            <div class="columns">
                                <div class="column is-7 is-offset-3">
                                    <div class="is-aligned-right">
                                        <button class="button is-info" @click.prevent="addOffice">
                                            <span v-text="$t('add_office_button_label')"></span>
                                        </button>
                                        <button class="button is-primary" :disabled="errors.any()" @click.prevent="submit">
                                            <span v-text="$t('register_button_label')"></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <b-modal :active.sync="showAvatarSelector">
            <div class="modal-card" id="avatars-modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ $t('doctorRegister_title') }}</p>
                </header>
                <section class="modal-card-body has-text-centered">
                    <div v-for="(avatarPath, avatar) in avatars" class="is-inline-block mx-2 my-2" :class="avatar == newDoctor.avatar ? 'selected-avatar' : 'unselected-avatar'">
                        <a href="#" @click.prevent="selectAvatar(avatar)">
                            <avatar :avatar="avatar" :name="avatarPath" class="image is-96x96"></avatar>
                        </a>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" type="button" @click="toggleAvatarSelector(false)">{{ $t('cancel_button_label') }}</button>
                </footer>
            </div>
        </b-modal>
    </section>
</template>

<script>
import axios from 'axios'
import firebase from 'firebase/app'
import helpers from '@/mixins/helpers'
import { store } from '@/store'

const GEOCODE_BASE_URL = 'https://maps.googleapis.com/maps/api/geocode/json'

export default {
    name: 'register',

    mixins: [helpers],

    data () {
        return {
            acceptTerms: false,
            socialEmail: firebase.auth().currentUser.email,
            medicalPractices: [
                'DENTIST',
                'GENERAL_PRACTITIONER',
                'GYNECOLOGIST',
                'OPHTHALMOLOGIST',
                'PEDIATRICIAN',
                'PSYCHOLOGIST',
                'DERMATOLOGIST',
                'OSTEOPATH',
                'PSYCHIATRIST',
                'PHYSIOTHERAPIST',
            ],
            newDoctor: {
                avatar: process.env.DEFAULT_AVATAR,
                lastName: "",
                firstName: "",
                contactEmail: firebase.auth().currentUser.email,
                inami: "",
                isRegulated: false,
                language: "en",
                type: 'DENTIST',
                countryId: ""
            },
            newOffices: [],
            avatars: process.env.AVATARS,
            showAvatarSelector: false
        }
    },

    computed: {
        error () {
            return store.state.formError
        }
    },

    created () {
        this.setFormError(null)

        // Use navigator language if available
        var navigatorLanguage = navigator.language || 'en';
        this.newDoctor.language = navigatorLanguage.substring(0, 2);

        const language = navigatorLanguage === 'en' ? 'en' : navigatorLanguage + '_BE'
        window.location.href = `https://pro.tooddoc.com/login?source=old_version&lang=${language}`

        if (! this.defaultCountryId) {
            var country = _.find(this.countries, {code: 'be'})

            if (country) {
                store.dispatch('setDefaultCountryId', country.id)
            }
        }

        this.newDoctor.countryId = this.defaultCountryId

        // TODO: change the locale of the app

        this.addOffice();
    },

    methods: {
        getCurrentCountryPhonePrefix(office) {
            return this.countries[office.countryId] ? this.countries[office.countryId].phonePrefix : ''
        },

        deleteError () {
            this.setFormError(null)
        },

        addOffice () {
            this.newOffices.push({
                "name": "",
                "streetName": "",
                "streetNumber": "",
                "zipCode": "",
                "locality": "",
                "location": null,
                "phone": "",
                "countryId": this.newDoctor.countryId
            })
        },

        removeOffice (key) {
            this.newOffices.splice(key, 1)
        },

        geocode (key) {
            // var vue = this

            return axios.get(GEOCODE_BASE_URL, {
                params: {
                    address: this.getFullAddress(key),
                    key: process.env.GEOCODING_API_KEY
                }
            }).then(({data}) => {
                if (data.results.length) {
                    this.newOffices[key].location = new firebase.firestore.GeoPoint(data.results[0].geometry.location.lat, data.results[0].geometry.location.lng)
                } else {
                    this.alertError(this.$t('DoctorProfile.geocoding_no_results_found'))
                }
            })
        },

        getPhoneRegex (officeKey) {
            return '^(\\' + this.getCountryPhonePrefix(officeKey) + '[0-9]{8,10})$'
        },

        getCountryName (officeKey) {
            return this.$t('Countries.' + (this.countries[this.newOffices[officeKey].countryId] ? this.countries[this.newOffices[officeKey].countryId].code : 'default'))
        },

        getCountryPhonePrefix(officeKey) {
            return this.countries[this.newOffices[officeKey].countryId] ? this.countries[this.newOffices[officeKey].countryId].phonePrefix : ''
        },

        getFullAddress (key) {
            return `${this.newOffices[key].streetNumber} ${this.newOffices[key].streetName},${this.newOffices[key].zipCode} ${this.newOffices[key].locality} ${this.getCountryName(key)}`
        },

        toggleAvatarSelector (show) {
            this.showAvatarSelector = show
        },

        selectAvatar (avatar) {
            this.newDoctor.avatar = avatar
            this.toggleAvatarSelector(false)
        },

        submit() {
            var vm = this

            if (store.state.loading) {
                return false
            }

            this.setLoading(true)
            this.setFormError(null)

            this.$validator.validateAll().then((result) => {
                if (! result) {
                    this.setLoading(false)

                    return false
                }

                var promises = []

                for (var k in this.newOffices) {
                    promises.push(this.geocode(k))


                    this.newOffices[k].name = this.newOffices[k].name.trim()
                    this.newOffices[k].name = this.newOffices[k].name.charAt(0).toUpperCase() + this.newOffices[k].name.slice(1)
                    this.newOffices[k].streetName = this.newOffices[k].streetName.trim()
                    this.newOffices[k].streetName = this.newOffices[k].streetName.charAt(0).toUpperCase() + this.newOffices[k].streetName.slice(1)
                    this.newOffices[k].locality = this.newOffices[k].locality.trim()
                    this.newOffices[k].locality = this.newOffices[k].locality.charAt(0).toUpperCase() + this.newOffices[k].locality.slice(1)
                }

                Promise.all(promises).then(() => {
                    // Make sure last & first names starts with an uppercase
                    vm.newDoctor.lastName = vm.newDoctor.lastName.trim()
                    vm.newDoctor.lastName = vm.newDoctor.lastName.charAt(0).toUpperCase() + vm.newDoctor.lastName.slice(1);
                    vm.newDoctor.firstName = vm.newDoctor.firstName.trim()
                    vm.newDoctor.firstName = vm.newDoctor.firstName.charAt(0).toUpperCase() + vm.newDoctor.firstName.slice(1);

                    store.dispatch('createDoctor', { doctor: vm.newDoctor, offices: vm.newOffices })

                    // this.setLoading(false)
                }, (error) => {
                    this.alertError(error.message)
                    this.setLoading(false)
                })
            });
        },

        logout () {
            store.dispatch('logout', {name: 'doctor.login'})
        }
    },

    watch: {
        'newDoctor.language' (to, from) {
            this.setLocale(to)
        }
    }
}
</script>

<style scoped>
    .modal-card#avatars-modal-card {
        margin: 0 auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/Doctor/Register.vue